import { Preview } from '@/components/preview/Preview';
import { WorkPilars } from './components/workPilars';
import { OurPlatform } from './components/ourPlatform';
import styles from './home.module.css';
import AwesomeSlider from 'react-awesome-slider';

// @ts-ignore
import withAutoplay from 'react-awesome-slider/dist/autoplay';
import 'react-awesome-slider/dist/styles.css';
import Image from 'next/image';
import { FitLayout } from '@/components/fitLayout';
import { Button } from '@/components/button';
import { Faqs } from '@/components/faqs';
import { ContactForm } from '@/features/contactForm';

interface ClientCardProps {
  name: string;
  description: string;
  image: string;
  url?: string;
}
const ClientCard = (props : ClientCardProps) => {
  const {
    name,
    description,
    image,
    url
  } = props;

  return (
    <div className={styles.client_card}>
      <div className={styles.client_card_background}>
      <Image
          src={image}
          className={styles.client_card_image}
          fill
          alt={name}
          sizes="(max-width: 640px) 100vw,
            (max-width: 1280px) 50vw,
            (max-width: 1536px) 33vw,
            25vw"
        />
      </div>
      <div className={styles.preview__background_cover}></div>
      <div className={styles.client_card_content}>
        <div className={styles.client_card_title}>
          {name}
        </div>
        <div className={styles.client_card_description}>{description}</div>
        <Button
          label='Visitar web'
          href={url}
        />
      </div>
    </div>
  )
}
 

export default function Home() {

  const experienceData = [
    {
      title: "Años de experiencia",
      value: "+10",
    },
    {
      title: "Proyectos",
      value: "+20",
    },
    {
      title: "Clientes",
      value: "+10",
    },
    {
      title: "Exito",
      value: "100%",
    },
  ];


  const AutoplaySlider = withAutoplay(AwesomeSlider);

  return (
   <div>
      <Preview />
      <FitLayout className={styles.content}>
        <></>
        {/* <PurposalValue />
        <Experience className={styles.home_experience} data={experienceData}/> */}
        <WorkPilars />
        <OurPlatform />
        {/* <Packs /> */}
        {/* <WorkProcess /> */}
        
        {/* <h2 className={styles.content_block_title}>Nuestros clientes</h2>
        <AutoplaySlider
          bullets={false}
          play={true}
          cancelOnInteraction={false} // should stop playing on user interaction
          interval={5000}
        >
          {Config.clients.map((clientConfig, i) => 
            <div className={styles.client_card_wrapper} key={i}>
              <ClientCard {...clientConfig}/>
            </div>
          )}
        </AutoplaySlider> */}
        <ContactForm />
        <Faqs />
      </FitLayout>
    </div>
  )
}

